"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
// socket sends same objects but with dates like: { $date: number }
function fixMessageFields(message) {
    return __assign(__assign({}, message), { ts: parseDate(message.ts), _updatedAt: parseDate(message._updatedAt) });
}
function parseDate(socketDate) {
    if (!socketDate)
        return socketDate;
    if (lodash_1["default"].isString(socketDate))
        return socketDate;
    return moment_1["default"](socketDate.$date).toISOString();
}
exports["default"] = fixMessageFields;
